import Head from 'next/head';
import { useMemo } from 'react';

interface ProductJsonLdProps {
	sku: string | undefined;
	brand: string | undefined;
	image: string | undefined;
	name: string | undefined;
	price: number | undefined;
	priceCurrency?: string;
	inStock: boolean | undefined;
}

export const ProductJsonLd: React.FC<ProductJsonLdProps> = ({
	sku,
	brand,
	image,
	name,
	price,
	priceCurrency = 'MXN',
	inStock,
}) => {
	const jsonLd = useMemo(() => {
		if (!sku || !brand || !name || !price || !image) {
			return null;
		}

		return {
			'@context': 'http://schema.org',
			'@type': 'Product',
			sku,
			brand: {
				'@type': 'Brand',
				name: brand,
			},
			image,
			name,
			offers: {
				'@type': 'Offer',
				priceCurrency,
				price,
				availability: inStock ? 'InStock' : 'OutOfStock',
			},
		};
	}, [sku, brand, image, name, price, priceCurrency, inStock]);

	if (!jsonLd) {
		return null;
	}

	return (
		<Head>
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
			/>
		</Head>
	);
};
